module.exports = __webpack_public_path__ + "static/media/AchievementUpload_Template.3dddbd45.xlsx";